/**
 * CRM Customer Onboarding route constants.
 * Hierarchy: Home → CRM → Customer → Onboarding
 */
export const CRM_ONBOARDING_LIST_PATH = "/services/CRM/Customer/Onboarding";
export const CRM_ONBOARDING_ADD_PATH = "/services/CRM/Customer/Onboarding/add";
export const CRM_ONBOARDING_EDIT_PATH = (customerId) =>
  `/services/CRM/Customer/Onboarding/edit/${encodeURIComponent(customerId)}`;
export const CRM_ONBOARDING_VIEW_PATH = (customerId) =>
  `/services/CRM/Customer/Onboarding/view/${encodeURIComponent(customerId)}`;
